module.exports = __webpack_public_path__ + "static/media/service-window-product-type-1.a8a05c66.png";